angular.module('pitch.track')
.factory('ReportTrackModal', function(config, Modal) {
    'use strict';
    return {
        open: function(params, data) {
            return Modal.create(
                config.templateRoot + '/templates/smf/modals/report-track',
                params,
                data
            );
        }
    };
});



// WEBPACK FOOTER //
// ./src/SMFCoreClientBundle/Resources/js/angular/services/ReportTrackModal.js